import { Col, Container, Row } from "react-bootstrap";

import { Fragment, useState } from "react";

import Banner from "../components/Banner/Banner";
import useWindowScrollToTop from "../hooks/useWindowScrollToTop";
import Return from "../components/Aboutus/Return";
import Terms from "../components/SpecialOffer/Terms";


const TermsAndCondition = () => {

  useWindowScrollToTop();

  return (
    <Fragment>
      <Banner title="Terms And Conditions" />
   
        <Container className="filter-bar-contianer">
          
        </Container>
        <Container>
         <Terms/>
        
        </Container>
 
    </Fragment>
  );
};

export default TermsAndCondition;
